import axios from 'axios';
import type { AxiosInstance } from 'axios';
import { appConfig } from '@/types/appConfig.type.ts';

const API_URL: string = appConfig.VITE_API_BASE_URL

const instance: AxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    // Selects the back-office session on the API (bo_* cookies). Without it the
    // API reads the client (Klintt) session, which a BO account can never use.
    'X-Portal': 'bo',
    'Accept-Language': localStorage.getItem('language') || 'fr'
  }
});

export default instance;
